/**
 * Standard selectable option row (mobile optimized)
 */
export function OptionButton({
  id,
  label,
  sub,
  price,
  icon,
  selected,
  onClick,
}) {
  return (
    <button
      onClick={() => onClick(id)}
      className={`w-full flex items-center gap-3 px-4 py-3 sm:py-3.5 rounded-xl
        border text-left transition-all active:scale-[0.99] min-w-0
        ${
          selected
            ? "border-[#B8893A] bg-[#B8893A]/10 ring-1 ring-[#B8893A]/30"
            : "border-gray-200 hover:border-[#B8893A]/50 hover:bg-gray-50"
        }`}
    >
      {/* Icon */}
      {icon && (
        <span
          className={`flex-shrink-0 ${
            selected ? "text-[#B8893A]" : "text-gray-400"
          }`}
        >
          {icon}
        </span>
      )}

      {/* Text */}
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-semibold text-gray-800 truncate">
          {label}
        </span>

        {sub && (
          <span className="block text-xs text-gray-400 mt-0.5 truncate">
            {sub}
          </span>
        )}
      </span>

      {/* Price */}
      {price != null && (
        <span className="flex-shrink-0 text-xs sm:text-sm font-semibold text-[#B8893A] whitespace-nowrap">
          AED {price.toLocaleString()}
        </span>
      )}

      {/* Check */}
      {selected && !price && (
        <span className="flex-shrink-0 ml-auto">
          
        </span>
      )}
    </button>
  );
}

/**
 * Circle selector (mobile spacing improved)
 */
export function CircleButton({ value, selected, onClick }) {
  return (
    <button
      onClick={() => onClick(value)}
      className={`w-10 h-10 sm:w-11 sm:h-11 rounded-full border text-sm font-semibold
        transition-all active:scale-[0.95]
        ${
          selected
            ? "bg-[#B8893A] border-[#B8893A] text-white"
            : "border-gray-200 text-gray-600 hover:border-[#B8893A]/60"
        }`}
    >
      {value}
    </button>
  );
}

/**
 * Progress bar (smoother + mobile spacing)
 */
export function ProgressBar({ step, total }) {
  return (
    <div className="flex items-center gap-1 mb-5 sm:mb-6">
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={`flex-1 h-1 rounded-full transition-all duration-500 ${
            i < step ? "bg-[#B8893A]" : "bg-gray-200"
          }`}
        />
      ))}
    </div>
  );
}

/**
 * Trust bar (mobile wrap improved)
 */
export function TrustBar() {
  const items = [
    "No obligation",
    "Takes ~2 minutes",
    "100% free",
  ];

  return (
    <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 mt-5 pt-4 border-t border-gray-100 px-2">
      {items.map((t) => (
        <span
          key={t}
          className="flex items-center gap-1 text-[11px] sm:text-xs text-gray-400"
        >
          
          {t}
        </span>
      ))}
    </div>
  );
}

/**
 * Check icon (unchanged but cleaner default)
 */
export function CheckIcon({ color = "#B8893A", size = 16 }) {
  return ;
}

/**
 * Step label (mobile typography improved)
 */
export function StepLabel({ tag, title, description }) {
  return (
    <div className="mb-5 sm:mb-6">
      <p className="text-[11px] sm:text-xs font-semibold text-gray-400 mb-1 uppercase tracking-widest">
        {tag}
      </p>

      <h2 
        className="font-bold text-[#000000] mb-1"
        style={{ 
          fontSize: "clamp(18px, 2.5vw, 22px)",
          fontWeight: "700",
          lineHeight: "1.3"
        }}
      >
        {title}
      </h2>

      {description && (
        <p 
          className="text-gray-500"
          style={{ 
            fontSize: "clamp(13px, 1.1vw, 15px)",
            lineHeight: "1.6"
          }}
        >
          {description}
        </p>
      )}
    </div>
  );
}
